import React, {useEffect, useState} from 'react';
import { FileWithMeta, IUploadDocumentModalView } from "./type/upload-document-modal.types";
import { RcFile } from "antd/lib/upload";
import { Modal, } from "antd/lib";
import DocumentTypeSelector from "./component/document-type-selector";
import FileUploader from "./component/file-uploader";
import { MetaPayload } from "../../../domains/models/document";
import MetaFileList from "./component/meta-file-list";


const UploadDocumentModalView: React.FC<IUploadDocumentModalView> = (props) => {

    const [uploadedFiles, setUploadedFiles] = useState<FileWithMeta[]>([]);

    useEffect(() => {
        if (!props.open) {
            setUploadedFiles([]);
        }
    }, [props.open]);

    function handleMetaFormSubmit(uid: string, meta: MetaPayload) {
        setUploadedFiles((prev) =>
            prev.map(item =>
                item.file.uid === uid
                    ? {...item, meta}
                    : item
            )
        );
    }

    async function handleSubmit() {
        const payload = uploadedFiles.map(item => ({
            file: item.file,
            meta: item.meta
        }));

        await props.handleFileSubmit(payload);
        props.handleModalClose();
    }

    function updateFiles(file: RcFile) {
        setUploadedFiles((prev) => [
            ...prev,
            {file, meta: undefined}
        ]);
    }

    const handleDelete = (fileToDelete: RcFile) => {
        setUploadedFiles((prev) =>
            prev.filter(item => item.file.uid !== fileToDelete.uid)
        );
    };

    function handleGlobalMetaData(meta: MetaPayload) {
        setUploadedFiles((prev) =>
            prev.map(item => ({...item, meta}))
        );

    }

    const Title = () => (
        <div className="upload-header">
            <div className="upload-header__icon">
                <img className="upload-header__icon-image" src="/images/photo.png"/>
            </div>
            <div className="upload-header__content">
                <h4 className="upload-header__title">{props.title ? props.title : 'Upload Document'}</h4>
                <p className="upload-header__description">
                    {props.allowMultiple ? ' Upload one or multiple images' : 'Upload File'}
                </p>
            </div>
        </div>
    )
    const files = uploadedFiles.map(item => item.file);

    return (
        <Modal
            title={<Title/>}
            open={props.open}
            onCancel={props.handleModalClose}
            onOk={handleSubmit}
            okText={'Submit'}
            className={'hrms-app upload-document-modal'}
        >
            <DocumentTypeSelector
                showDocumentList={props.showDocumentList}
                documentListOption={props.documentListOption}
                selectedDocumentType={props.selectedDocumentType}
                handleDocTypeChange={props.handleDocTypeChange}
            />

            <FileUploader
                documentValidationsByType={props.documentValidationsByType}
                allowMultiple={props.allowMultiple}
                uploadedFiles={files}
                updateFiles={updateFiles}
                isEnabled={Boolean(props.documentType || props.selectedDocumentType)}
                handleDelete={handleDelete}
            />

            <MetaFileList
                uploadedFiles={uploadedFiles}
                handleFileDelete={handleDelete}
                metaData={props.metaData}
                handleMetaFormSubmit={handleMetaFormSubmit}
                handleGlobalMetaData={handleGlobalMetaData}
            />

        </Modal>
    )
}


export default UploadDocumentModalView;
